import React, {useState} from "react";
import { buyerReviewAndCorrectHeadCells } from "./data";
import InfoCard from "../../deprecatedUikit/InfoCard/InfoCard";

const BuyerInventoryRecordCard = ({inventoryRecord, handleDeleteCorrection, handleSubmitCorrection}) => {
    const [expanded, setExpanded] = useState(false);

    let actionButtons = [];
    let visibleButton;

    const pendingStatus = 'PENDING';

    const checkInCorrection = {id: inventoryRecord.checkInCorrectionId, status: inventoryRecord.checkInCorrectionStatus};
    const checkOutCorrection = {id: inventoryRecord.checkOutCorrectionId, status: inventoryRecord.checkOutCorrectionStatus};

    if (checkInCorrection.status === pendingStatus && checkInCorrection.id) {
        actionButtons.push({label: "Retract Check In Correction", onClick: () => handleDeleteCorrection(checkInCorrection.id)})
    }
    if (checkOutCorrection.status === pendingStatus && checkOutCorrection.id) {
        actionButtons.push({label: "Retract Check Out Correction", onClick: () => handleDeleteCorrection(checkOutCorrection.id)})
    }
    if (checkInCorrection.status !== pendingStatus && checkOutCorrection.status !== pendingStatus && (!checkInCorrection.id || !checkOutCorrection.id)) {
        actionButtons.push({label: "Submit a New Correction", onClick: (item) => handleSubmitCorrection(item.checkInId)});
        visibleButton = {label: "Submit Correction", onClick: (item) => handleSubmitCorrection(item.checkInId)};
    }

    return <InfoCard
                data={inventoryRecord}
                key={inventoryRecord.id}
                headCells={buyerReviewAndCorrectHeadCells}
                collapse={expanded}
                handleToggle={() => setExpanded(!expanded)}
                actionItems={actionButtons}
                visibleButton={visibleButton}
            />
};

export default BuyerInventoryRecordCard;
